'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/customizeOrder'));
    processInclude(require('./product/deferredPdpModals'));
    processInclude(require('./product/detail'));
    processInclude(require('./product/loyalty'));
    processInclude(require('plugin_wishlists/product/wishlist'));
    processInclude(require('./product/productMediaLeft'));
    processInclude(require('./product/selectPDPQuantity'));
    processInclude(require('./product/addtowishlist'));
    processInclude(require('./product/pdpEnquireForm'));
    processInclude(require('./product/sticky'));
    processInclude(require('./product/voucherForOthers'));
    processInclude(require('./product/bulkOrder'));
    processInclude(require('./product/diamondAddToCart'));
    processInclude(require('./product/storeAppointment'));
    processInclude(require('./product/servicebilityCheck'));
});
